import { type FC, memo } from "react";
import { type KeyValue, KeyValueTable } from "@/components/fragments/table/key-value-table";
import { konamiSportsTableLabelTestId, konamiSportsTableTestId } from "./const";
import { Box } from "@/components/essentials/box";
import { Typography } from "@/components/essentials/typography";
import { type KonamiSportsFormValue } from "@/components/fragments/argyle/konami-sports-form";

export interface KonamiSportsTableProps {
  readonly value: KonamiSportsFormValue;
}

export const KonamiSportsTable: FC<KonamiSportsTableProps> = memo(({ value: { konamiSports } }) => {
  const konamiSportsKeyValueData: KeyValue[] = [
    {
      key: "施設名",
      value: konamiSports?.shisetsu ?? "",
    },
    {
      key: "コナミスポーツクラブ会員番号",
      value: konamiSports?.memberCode ?? "",
    },
  ];

  return (
    <Box data-testid={konamiSportsTableTestId}>
      <Typography variant="display6" mb="4" data-testid={konamiSportsTableLabelTestId}>
        コナミスポーツクラブ会員情報
      </Typography>
      <KeyValueTable data={konamiSportsKeyValueData} />
    </Box>
  );
});

KonamiSportsTable.displayName = "KonamiSportsTable";
